import ModuleHero from '../components/ModuleHero';
import PageCourse from '../components/PageCourse';
import ModuleTopics from '../components/ModuleTopics';
import Layout from '../components/Layout';
import ModuleFeaturedCourse from '../components/ModuleFeaturedCourse';
import ModuleMultiColumnCourses from '../components/ModuleMultiColumnCourses';
import LayoutSection from '../components/LayoutSection';
import ModuleCard from '../components/ModuleCard';
import Categories from '../components/Categories';
import PageCourseTopic from '../components/PageCourseTopic';
import ModuleRichText from '../components/ModuleRichText';
import ModuleTextList from '../components/ModuleTextList';
import ModuleMultiColumnCards from '../components/ModuleMultiColumnCards';
import ModuleCarousel from '../components/ModuleCarousel';
import ModuleMultiColumnVideos from '../components/ModuleMultiColumnVideos';
import ModuleTextMedia from '../components/ModuleTextMedia';
import ModuleFullWidthContainer from '../components/ModuleFullWidthContainer';
import ModuleFeaturedContent from '../components/ModuleFeaturedContent';
import ElementVideo from '../components/ElementVideo';
import ElementLink from '../components/ElementLink';
import SocialLinks from '../components/SocialLinks';
import ModuleAccordian from '../components/ModuleAccordion/ModuleAccordion';
import ModuleChecklist from '../components/ModuleChecklist/ModuleChecklist';
import PageVideo from '../components/PageVideo';
import ModuleNavattic from '../components/ModuleNavattic';
import Personalization from '../components/Personalization';
import ElementImage from '../components/ElementImage/ElementImage';
import ModuleMultiColumnvideos from '../components/ModuleMultiColumnvidoes';

export default {
  moduleHero: ModuleHero,
  pageCourse: PageCourse,
  moduleTopics: ModuleTopics,
  settingsGlobal: Layout,
  moduleFeaturedCourse: ModuleFeaturedCourse,
  moduleMultiColumnCourses: ModuleMultiColumnCourses,
  layoutSection: LayoutSection,
  moduleCard: ModuleCard,
  categories: Categories,
  pageCourseTopic: PageCourseTopic,
  moduleRichText: ModuleRichText,
  moduleTextList: ModuleTextList,
  moduleMultiColumnCards: ModuleMultiColumnCards,
  moduleCarousel: ModuleCarousel,
  moduleMultiColumnVideos: ModuleMultiColumnVideos,
  moduleTextMedia: ModuleTextMedia,
  moduleFullWidthContainer: ModuleFullWidthContainer,
  moduleFeaturedContent: ModuleFeaturedContent,
  elementVideo: ElementVideo,
  elementLink: ElementLink,
  socialLinks: SocialLinks,
  moduleAccordion: ModuleAccordian,
  pageVideo: PageVideo,
  moduleChecklist: ModuleChecklist,
  moduleNavattic: ModuleNavattic,
  testPersionalization: Personalization,
  elementImage: ElementImage,
  moduleMultiColumnVidoes: ModuleMultiColumnvideos,
};
